// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__TF14c","content":"ManualTimeModal_content__2hk48"};